module.exports = __webpack_public_path__ + "img/820.7c86295f.png";